<template>
  <div :id="chartData._id" ref="warpRef" class="jzliu-bi-engine-chart-warp indicator-card"
    :style="{ height: warpHeight }">
    <div class="indicator-card-warp" ref="warp" :style="{ height: warpHeight }">
      <div v-for="(i, idx) in cardList" class="card-item" :style="{ width: cardWidth }" :key="idx">
        <component :idx="idx" :is="computedTpl" :chartData="chartData" :info="i"></component>
        <p class="right-border" v-show="rightLineShow(idx)"></p>
        <p class="bottom-border" v-show="leftLineShow(idx)"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategoryDimension } from '../../utils/utils'
import { transferWhiteVal } from '../../utils'
import { elResizeObverse } from '../../utils'
import { formatIndicatorData, initHeight } from '../../utils/index'
import style1 from './indicatorStyle/style1.vue'
import style2 from './indicatorStyle/style2.vue'
import style6 from './indicatorStyle/style6.vue'
import { getSeriesFieldValues } from '../../utils/utils'
export default {  
  name: 'cIndicatorCard',
  components: {
    style1,
    style2, 
    style6,
  },
  props: {
    chartData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      transferWhiteVal,
      cardList: [],
      warpHeight: 200,
      cardWidth: '25%',
      // 最后一行的卡片需要补齐宽度
      fixConf: {
        width: -1,
        baseNum: 0,
      },
      renderTimer: null,
    }
  },
  watch: {
    'chartData.styleConfig.helperData.indicatorRowIconMap': {
      handler() {
        this.debounceRenderChart()
      },
      deep: true
    }
  },
  computed: {
    computedTpl() {
      return this.chartData.styleConfig.commongConfig.indicatorStyle ? 'style' + this.chartData.styleConfig.commongConfig.indicatorStyle : 'style1'
    },
    rightLineShow() {
      return (idx) => {
        idx = idx + 1
        if (idx % this.getColsMaxNum === 0) {
          return false
        }
        return true
      }
    },
    leftLineShow() {
      return (idx) => {
        const num = this.cardList.length % this.getColsMaxNum
        if (idx > this.cardList.length - 1 - (num === 0 ? this.getColsMaxNum : num)) {
          return false
        }
        return true
      }
    },
    getColsMaxNum() {
      return parseInt(100 / parseInt(this.cardWidth))
    },
  },
  mounted() {
    this.$nextTick(() => {
      initHeight.call(this, 'warpHeight')
      this.renderChart()
    })
    // 响应式监测 针对pc和移动端之间切换的兼容
    const el = this.$refs.warpRef
    elResizeObverse(el, () => {
      this.$nextTick(() => {
        this.warpHeight = this.$parent?.el?.offsetHeight ?? this.warpHeight  - 16
        console.log('warpHeight', el.offsetHeight, this.$parent?.el?.offsetHeight)
        this.computedSty()
      })
    })
  },
  methods: {
    debounceRenderChart() {
    if (this.renderTimer) {
      clearTimeout(this.renderTimer)
    }
      this.renderTimer = setTimeout(() => {
        this.renderChart()
      }, 300) // 300ms 防抖延迟
    },
    computedSty() {
      let w = ''
      const width = this.$refs?.warp?.offsetWidth
      if (this.cardList.length === 1) {
        w = '100%'
      } else {
        if (width <= 300) {
          w = '50%'
        } else if (width > 300 && width <= 500) {
          w = '50%'
        } else if (width > 500 && width < 1200) {
          w = '33%'
        } else {
          w = '25%'
        }
      }
      this.cardWidth = w
    },
    renderChart() {
      const {
        data: {
          data: chartData,
        },
      } = this.chartData
      const { rows, values, columns } = getCategoryDimension(this.chartData.fields)
      const nameMap = this.chartData.styleConfig.helperData.nameMap
      const metaOrder = getSeriesFieldValues(this.chartData)?.seriesField?.values ?? []
      console.log('metaOrder:', metaOrder)
      this.cardList = formatIndicatorData(this.chartData.fields, chartData,metaOrder).map(item => {
        return {
          ...item,
          measureName: nameMap[values[0]] ?? item.measureName,
          rowValue: item.rowValue,
        }
      }).sort((a, b) => {
        return metaOrder.indexOf(a.rowValue) - metaOrder.indexOf(b.rowValue)
      })
      console.log('this.cardList:', this.cardList)
    },
  },
  destroyed() {
  // 清理工作
  },
}
</script>

<style scoped lang="less">
.indicator-card {
  overflow: auto;
  p {
    margin: 0;
  }
  .indicator-card-warp {
    .card-item {
      overflow: hidden;
      text-overflow: ellipsis;
      position: relative;
      padding: 24px 12px;
      width: 25%;
      display: inline-block;
      // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .right-border,
      .bottom-border {
        position: absolute;
        background: rgba(0, 0, 0, 0.1);
      }
      .right-border {
        width: 1px;
        right: 0;
        bottom: 10%;
        height: 80%;
      }
      .bottom-border {
        bottom: 0;
        left: 5%;
        height: 1px;
        width: 90%;
      }
      p {
        color: #000;
      }
      .list-content {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        margin-bottom: 6px;
        span:first-child {
          flex: 1;
        }
        span:last-child {
          width: 80px;
        }
      }
    }
    .top-list {
      flex-direction: column;
      span:last-child {
        font-weight: bold;
        font-size: 24px;
        width: 100% !important;
      }
    }
  }
}
</style>
